import { render, staticRenderFns } from "./FeedProductSubtype.vue?vue&type=template&id=b91d7c42&"
import script from "./FeedProductSubtype.vue?vue&type=script&lang=ts&"
export * from "./FeedProductSubtype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports